export default __webpack_public_path__ + "static/media/yellow_shake_up.536bc5f3.png";